export default "__VITE_ASSET__BPnTZA7$__"